import {
	API_GET_ALL_LABORATORY,
	API_ADMIN_GET_ALL_LABORATORY,
	API_ADMIN_GET_LABORATORY,
	ADMIN_INIT_NEW_LABORATORY,
	ADMIN_RESET_FOCUS_LABORATORY,
	API_ADMIN_POST_LABORATORY,
	API_ADMIN_PATCH_LABORATORY,
	API_ADMIN_DELETE_LABORATORY,
	API_SEARCH_LABORATORY
} from 'actions/laboratory';
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";

export const getVersion = (action) => {
	const path = pathMapping[action];
	return {
		path: path ? path[path.currentClient] : undefined,
		currentClient: path ? path.currentClient : DEFAULT_CLIENT,
	}
}

const pathMapping = {
	[API_GET_ALL_LABORATORY]: {
		default: `/laboratories`,
		v2: `/laboratories`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_SEARCH_LABORATORY]: {
		default: (size, start) => `/laboratories/search/${size}/${start}`,
		v2: (size, start) => `/laboratories/search/${size}/${start}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_GET_ALL_LABORATORY]: {
		default: `/admin/laboratories`,
		v2: `/laboratories/admin`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_GET_LABORATORY]: {
		default: (laboratoryId) => `/admin/laboratories/${laboratoryId}`,
		v2: (laboratoryId) => `/laboratories/admin/${laboratoryId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_POST_LABORATORY]: {
		default: `/admin/laboratories`,
		v2: `/laboratories/admin`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_PATCH_LABORATORY]: {
		default: (laboratoryId) => `/admin/laboratories/${laboratoryId}`,
		v2: (laboratoryId) => `/laboratories/admin/${laboratoryId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_DELETE_LABORATORY]: {
		default: (laboratoryId) => `/admin/laboratories/${laboratoryId}`,
		v2: (laboratoryId) => `/laboratories/admin/${laboratoryId}`,
		currentClient: DEFAULT_CLIENT,
	},
};

const adaptLaboratoryRequest = (laboratory, currentClient) => {
	if (!laboratory || currentClient !== V2_CLIENT) {
		return laboratory;
	}

	const adapted = { ...laboratory };

	// Frontend admin forms use snake_case, v7 DTO expects camelCase.
	if (adapted.ip_range !== undefined && adapted.ipRange === undefined) {
		adapted.ipRange = adapted.ip_range;
	}
	if (adapted.folder_num_format !== undefined && adapted.folderNumFormat === undefined) {
		adapted.folderNumFormat = adapted.folder_num_format;
	}

	// Map nested labParamGroup -> labParamGroupId
	if (adapted.labParamGroup && adapted.labParamGroup.id !== undefined && adapted.labParamGroupId === undefined) {
		adapted.labParamGroupId = adapted.labParamGroup.id;
	}

	// Keep only fields accepted by v7 DTO (extra fields are ignored by backend, but this is cleaner).
	return {
		id: adapted.id,
		name: adapted.name,
		ipRange: adapted.ipRange,
		folderNumFormat: adapted.folderNumFormat,
		labParamGroupId: adapted.labParamGroupId,
	};
};

export function getAllLaboratories() {
	const version = getVersion(API_GET_ALL_LABORATORY);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_GET_ALL_LABORATORY,
		payload: {
			client: version.currentClient,
			request: {
				url
			}
		}
	};
}

export function adminGetAllLaboratories() {
	const version = getVersion(API_ADMIN_GET_ALL_LABORATORY);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_ADMIN_GET_ALL_LABORATORY,
		payload: {
			client: version.currentClient,
			request: {
				url
			}
		}
	};
}

export function searchLaboratories(searchData, size, start) {
	const version = getVersion(API_SEARCH_LABORATORY);
	const url = typeof version.path === 'function' ? version.path(size, start) : version.path;
	return {
		type: API_SEARCH_LABORATORY,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: 'GET',
				params: searchData
			}
		}
	};
}

export function adminGetLaboratory(laboratory) {
	const version = getVersion(API_ADMIN_GET_LABORATORY);
	const url = typeof version.path === 'function' ? version.path(laboratory.id) : version.path;
	return {
		type: API_ADMIN_GET_LABORATORY,
		payload: {
			client: version.currentClient,
			request: {
				url
			}
		}
	};
}

export function adminPostLaboratory(laboratory) {
	const version = getVersion(API_ADMIN_POST_LABORATORY);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	const data = adaptLaboratoryRequest(laboratory, version.currentClient);
	return {
		type: API_ADMIN_POST_LABORATORY,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: 'POST',
				data
			}
		}
	};
}

export function adminPatchLaboratory(laboratory) {
	const version = getVersion(API_ADMIN_PATCH_LABORATORY);
	const url = typeof version.path === 'function' ? version.path(laboratory.id) : version.path;
	const data = adaptLaboratoryRequest(laboratory, version.currentClient);
	return {
		type: API_ADMIN_PATCH_LABORATORY,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: 'PATCH',
				data
			}
		}
	};
}

export function adminDeleteLaboratory(laboratory) {
	const version = getVersion(API_ADMIN_DELETE_LABORATORY);
	const url = typeof version.path === 'function' ? version.path(laboratory.id) : version.path;
	return {
		type: API_ADMIN_DELETE_LABORATORY,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: 'DELETE'
			}
		}
	};
}

export function initNewLaboratory() {
	return {
		type: ADMIN_INIT_NEW_LABORATORY
	};
}

export function resetFocusLaboratory() {
	return {
		type: ADMIN_RESET_FOCUS_LABORATORY
	};
}
